// extracted by mini-css-extract-plugin
export default {"left":"aMu9Be","external":"bMu9Be","center":"cMu9Be","right":"dMu9Be"};